import Panel from '@admin/components/panel'

const mapPropsToPanel = (props, context) => ({
  title: 't(Subdomains)',
  collection: {
    endpoint: `/api/admin/truevail/admin/deliverability/segments/${props.segment.id}/subdomains`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Domain)', key: 'domain.name', sort: 'domain', primary: true },
      { label: 't(Warming)', key: 'warming_enabled', collapsing: true, format: 'check_times' },
      { label: 't(Queued)', key: 'queued_count', collapsing: true, align: 'right' }
    ],
    defaultSort: { key: 'domain', order: 'asc' },
    empty: {
      svg: 'globe',
      title: 't(No Subdomains)',
      text: 't(There are no subdomains for this segment)'
    },
    entity: 'domain_segment',
    onClick: (record) => context.router.push(`/admin/truevail/admin/domain_segments/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)